import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { Letsikring } from './letsikring.model';

@Injectable({
  providedIn: 'root',
})
export class LetsikringApi extends RestApi<Letsikring> {
  endpoint = '/api/admin/letsikringer';
}
